import React from "react";
import CirclesContainer from "../Circle/CirclesContainer";
import BackgroundWithLines from "./BackgroundWithLines";
import "./background.scss";

const Background = () => {
  return (
    <div className="background-container">
      <CirclesContainer />
      <BackgroundWithLines theme={"blue"} />
    </div>
  );
};

Background.defaultProps = {};

Background.propTypes = {};

export default Background;
